<script setup lang="ts">
defineProps<{
  image: string
}>()
</script>
<template>
  <LayoutCard>
    <div class="grid gap-6 sm:grid-cols-12">
      <div class="sm:order-2 sm:col-span-5">
        <div class="overflow-hidden rounded-lg bg-zinc-100">
          <img
            class="aspect-video w-full rounded-lg"
            :src="image"
            alt="media"
            loading="lazy"
          />
        </div>
      </div>
      <div class="sm:order-1 sm:col-span-7">
        <div class="flex h-full flex-col items-start justify-between">
          <TypographyHeading data-testid="infocard_heading">
            <slot name="title" />
          </TypographyHeading>
          <div class="mt-1 h-full text-zinc-500 sm:mt-2">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </LayoutCard>
</template>
